import React from "react";
import Grid from '@mui/material/Grid';
import { HorizontalSeparator } from "../styled/Tooltip.styled";
import {
  Row,
  IconBox,
  LogoWrapper
} from "../styled/Tooltip.styled";

const DemandTooltip = ({ headerData, bodyData = [], geohash }) => {
  const { img: headerImg, title, colorBox, value: headerValue, logo, name, isAnonymized } = headerData;
  return (
    <>
      <div
        style={{
          minWidth: "250px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {isAnonymized ? (
          <LogoWrapper
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "30px"
            }}
          ><h4 style={{
              color: "#707070",
              fontSize: "10px",
              textAlign: "center",
              lineHeight: "18px",
              border: "1px solid #016F35",
              borderRadius: "4px",
              padding: "4px 5px",
              display: "inline-block",
              margin: "0"
            }}>
              {name}
            </h4>
          </LogoWrapper>
        )
          : !isAnonymized && logo ? (
            <Row style={{ height: "30px" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <LogoWrapper align={"center"} width={"55px"} height={"30px"}>
                  <img
                    src={logo}
                    alt="logo1"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </LogoWrapper>
              </div>
            </Row>
          ) : (
            <Grid container style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '50px', marginTop: '-25px', paddingLeft: '5px' }} spacing={3}>
              <Grid item md={2} style={{ marginRight: '-8px' }}>
                {headerImg && <img src={`/assets/${headerImg}.png`} className="center" style={{ width: "15px" }} alt={headerImg} />}
              </Grid>
              <Grid item md>
                <p style={{ color: '#000000', font: 'normal normal 600 14px/19px Open Sans' }}>{title === "Final Score" ? "Demand Score" : title}</p>
              </Grid>
              <Grid item style={{ display: 'flex', flexDirection: 'row' }} md={4}>
                {colorBox && <IconBox marginTop={'17px'} marginRight={'5px'} backgroundColor={`${colorBox} 0% 0% no-repeat padding-box`} />}
                <p style={{ color: '#000000', font: 'normal normal 600 14px/19px Open Sans', width: "100%" }}>{headerValue}</p>
              </Grid>
            </Grid>
          )}
        <HorizontalSeparator />
        {bodyData.map((item, idx) => {
          const { img, text, value, bold = false, colorBox: colorBoxBody } = item;
          return (
            <Grid
              key={idx}  // Add key here
              container
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: idx === bodyData.length - 1 ? '50px' : '45px',
                marginTop: idx === 0 && '-20px',
                paddingLeft: '5px',
              }}
              spacing={3}
            >
              <Grid item md={2} style={{ marginRight: '-8px' }}>
                {img && <img src={`/assets/${img}.png`} className="center" style={{ width: "15px" }} alt={img} />}
              </Grid>
              <Grid item md>
                <p style={{ color: bold ? '#000000' : '#707070', font: 'normal normal 600 14px/19px Open Sans', fontWeight: bold ? 'bold' : 'normal' }}>{text}</p>
              </Grid>
              <Grid item style={{ display: 'flex', flexDirection: 'row' }} md={4}>
                {colorBoxBody && <IconBox marginTop={'17px'} marginRight={'5px'} backgroundColor={`${colorBoxBody} 0% 0% no-repeat padding-box`} />}
                <p style={{ color: bold ? '#000000' : '#707070', font: 'normal normal 600 14px/19px Open Sans', fontWeight: bold ? 'bold' : 'normal' }}>{value}</p>
              </Grid>
            </Grid>
          );
        })}
        <HorizontalSeparator />
        {geohash
          ? <p style={{ color: '#707070', font: 'normal normal 600 11px/19px Open Sans', textAlign: "center", margin: '0px' }}>{geohash.toUpperCase()}</p>
          : <></>}
      </div>
    </>
  );
};

export default DemandTooltip;
